import React from 'react';
import { Link, Schedule, CheckCircle, AccountBalance, Cancel } from '@mui/icons-material';

export const PaymentLinksStats = ({ stats }) => {
    const statItems = [
        {
            value: stats.total,
            label: 'Total Liens',
            icon: Link,
            color: 'from-blue-500 to-cyan-500',
            trend: '+12%'
        },
        {
            value: stats.pending,
            label: 'En Attente',
            icon: Schedule,
            color: 'from-amber-500 to-orange-500',
            trend: '+5%'
        },
        {
            value: stats.paid,
            label: 'Payés',
            icon: CheckCircle,
            color: 'from-emerald-500 to-green-500',
            trend: '+18%'
        },
        {
            value: stats.collected,
            label: 'Encaissés',
            icon: AccountBalance,
            color: 'from-violet-500 to-purple-500',
            trend: '+8%'
        },
        {
            value: stats.expired,
            label: 'Expirés',
            icon: Cancel,
            color: 'from-rose-500 to-red-500',
            trend: '-3%'
        }
    ];

    return (
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
            {statItems.map((stat, index) => (
                <div
                    key={stat.label}
                    className="group bg-white/80 backdrop-blur-xl rounded-2xl p-5 border border-slate-200 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
                >
                    <div className="flex items-start justify-between">
                        <div className="flex-1">
                            <div className="text-2xl font-bold text-slate-800">{stat.value}</div>
                            <div className="text-sm text-slate-600 mt-1">{stat.label}</div>
                            <div className="flex items-center mt-2">
                                <span className={`text-xs font-medium ${
                                    stat.trend.startsWith('+') ? 'text-emerald-600' : 'text-rose-600'
                                }`}>
                                    {stat.trend}
                                </span>
                            </div>
                        </div>
                        <div className={`p-2 rounded-xl bg-gradient-to-r ${stat.color} shadow-md group-hover:scale-110 transition-transform duration-300`}>
                            <stat.icon className="text-white text-lg" />
                        </div>
                    </div>

                    {/* Barre de progression subtile */}
                    <div className="mt-3 w-full bg-slate-200 rounded-full h-1">
                        <div
                            className={`h-1 rounded-full bg-gradient-to-r ${stat.color} transition-all duration-1000`}
                            style={{ width: `${Math.min((stat.value / (stats.total || 1)) * 100, 100)}%` }}
                        ></div>
                    </div>
                </div>
            ))}
        </div>
    );
};